import axios from 'axios';

const cachiosInstance = require('cachios').create(axios);

export default cachiosInstance;
